// Bileli · shared/api — the zod PARSE BOUNDARY. why: strong JSON contracts (user directive) — every hot
// repository validates backend payloads against a schema mirroring the OpenAPI DTO before mapping. Drift
// fails loudly in the console (with the endpoint + issues) instead of silently corrupting the UI.

import type { ZodType } from 'zod';

export class ApiContractError extends Error {}

export function parseApi<T>(schema: ZodType<T>, data: unknown, context: string): T {
  const result = schema.safeParse(data);
  if (!result.success) {
    // eslint-disable-next-line no-console
    console.error(`[bileli] API contract violation at ${context}:`, result.error.issues, data);
    throw new ApiContractError(`Неожиданный ответ сервера (${context}).`);
  }
  return result.data;
}
